import { ApiEndpointBuilder } from "@/services/api/types";
import { DataResponse } from "@/types/reponse-data";
import { SearchRequest } from "@/types/search-request";
import { UserInvitation } from "@/types/user";

export interface SearchUserInvitationsRequest extends SearchRequest {
  reason?: number;
  pendingOnly?: boolean;
}

const searchUserInvitationsEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.query<DataResponse<UserInvitation>, SearchUserInvitationsRequest>({
    query: request => ({
      url: "/invitations/search",
      method: "POST",
      body: request,
    }),
    providesTags: result =>
      result?.data
        ? [
            ...result.data.map(item => ({ type: "userInvitations" as const, id: item.id })),
            { type: "userInvitations" as const, id: "LIST" },
          ]
        : [{ type: "userInvitations" as const, id: "LIST" }],
  });
};

export default searchUserInvitationsEndpoint;
